import { createFileRoute } from "@tanstack/react-router";
import { ASSETS } from "#/lib/assets";
import { EggPill } from "../components/primitives.js";

export const Route = createFileRoute("/about")({
  head: () => ({ meta: [{ title: "About" }] }),
  component: AboutPage,
});

function AboutPage() {
  return (
    <div data-screen-label="About" className="pb-24">
      <section className="relative overflow-hidden pt-12 pb-12 md:pt-16 md:pb-16">
        <div className="relative mx-auto w-full max-w-figma px-6 md:px-10">
          <EggPill
            className="-translate-y-6 absolute top-1/2 right-[-40px] left-[40px] h-[360px] md:right-[-80px] md:left-[120px] md:h-[460px]"
            radius={240}
          />
          <div className="relative flex h-[360px] items-end justify-center md:h-[460px]">
            <div className="absolute inset-x-0 -top-7 flex justify-center">
              <div className="flex w-[78%] max-w-[640px] flex-col items-center justify-center rounded-2xl bg-white px-6 py-8 shadow-card md:w-[60%] md:px-10 md:py-12">
                <img
                  src={ASSETS.logo}
                  alt="Learning Plus"
                  className="h-16 w-auto md:h-20"
                />
                <p className="mt-4 text-center font-display font-semibold text-lp-green text-xl leading-tight md:text-3xl">
                  Love learning,
                  <br />
                  Love teaching
                </p>
              </div>
            </div>
            <img
              src={ASSETS.livingBooks[0] ?? ""}
              alt=""
              className="-translate-x-[150%] absolute bottom-0 left-1/2 hidden h-[180px] w-auto max-w-none rotate-[-6deg] rounded-md object-cover shadow-lg md:block md:h-[230px] top-[55%]"
            />
            <img
              src={ASSETS.livingBooks[1] ?? ""}
              alt=""
              className="-translate-x-[70%] absolute bottom-3 left-1/2 h-[160px] w-auto max-w-none rotate-[3deg] rounded-md object-cover shadow-lg md:h-[210px] top-[55%]"
            />
            <img
              src={ASSETS.lifepac}
              alt=""
              className="-translate-x-[10%] absolute bottom-1 left-1/2 h-[170px] w-auto max-w-none rotate-[-2deg] rounded-md object-cover shadow-lg md:h-[220px] top-[55%]"
            />
            <img
              src={ASSETS.livingBooks[2] ?? ""}
              alt=""
              className="absolute bottom-2 left-1/2 h-[160px] w-auto max-w-none translate-x-[40%] rotate-[7deg] rounded-md object-cover shadow-lg md:h-[210px] top-[55%]"
            />
            <img
              src={ASSETS.categories.childrens}
              alt=""
              className="absolute bottom-0 left-1/2 hidden h-[170px] w-auto max-w-none translate-x-[110%] rotate-[-5deg] rounded-md object-cover shadow-lg md:block md:h-[215px] top-[55%]"
            />
          </div>
        </div>
      </section>

      <section className="mx-auto w-full max-w-3xl px-6 pt-8 pb-16 md:px-10 md:pt-12">
        <h1 className="m-0 text-center font-bold font-display text-4xl text-lp-green-dk md:text-6xl">
          ABOUT US
        </h1>
        <p className="mt-8 text-center font-display text-base text-lp-text-dk leading-relaxed md:mt-10">
          Passionate about seeing the entire family enjoying and getting the
          most out of the homeschool journey, Learning Plus curates the best
          books and curriculum materials from all over the world. International
          favorites Apologia, BJU Press, Masterbooks, and AOP are side by side
          notable Filipino publishers like Everlearn, Rex Book Store, and C&E
          Publishing, in our extensive roster of curricula partners. From
          printed textbooks to online learning materials, our lineup of titles
          have been carefully selected, all meeting Philippine and international
          educational standards. Whatever your child's learning style may be or
          whichever homeschool season you may be in, we've already found the
          best learning materials for you
        </p>
        <p className="mt-8 text-center font-display text-lg text-lp-green-dk italic md:mt-10">
          —just sit back, relax, and relish the homeschool experience.
        </p>
      </section>
    </div>
  );
}
